<!--受伤类型-->
<template>
  <div
    class="hbn-container"
    id="userInfo"
  >
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="Query"
            label-width="100px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="受伤类型名称">
                  <el-input
                    id="Name"
                    v-model="Query.Name"
                    placeholder="受伤类型名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button
              size="mini"
              class="hbn-button-serach"
              @click="SearchOpt"
            >查找</el-button>
            <span
              class="control-collapse"
              @click="show = !show"
            >{{
              show ? "收起" : "展开"
            }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          @click="Opt('', 'New')"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
        <el-button
          type="primary"
          class="custom-button"
          @click="importExcel"
        >
          <i class="el-icon-upload custom-icon"></i>
          <span>导入</span>
        </el-button>
        <el-button
          type="primary"
          class="custom-button"
          @click="exportExcel"
        >
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
      </div>
      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            v-loading="pageData.loading"
            :data="pageData.tabledatas"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="selectAllChangeEvent"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              field="tableCheck"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template
              v-for="(item, key) in InjuryPart"
              :key="key"
            >
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
              ></vxe-table-column>
            </template>

            <vxe-table-column
              width="150"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ rowIndex }">
                <el-button
                  type="text"
                  size="small"
                  @click="Opt(rowIndex, 'Edit')"
                >编辑</el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="Opt(rowIndex, 'View')"
                >查看</el-button>
                <el-popconfirm
                  title="是否要删除?"
                  @confirm="Opt(rowIndex,'Del')"
                >
                  <template #reference>
                    <el-button
                      size="small"
                      type="text"
                    >删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="pageData.currentPage"
            :page-size="pageData.currentSize"
            :page-sizes="pageData.pagesizes"
            :total="pageData.total"
            :pager-count="5"
            :layouts="[
                  'PrevJump',
                  'PrevPage',
                  'JumpNumber',
                  'NextPage',
                  'NextJump',
                  'FullJump',
                  'Sizes',
                  'Total',
                ]"
            @page-change="handlePageChange"
          >
            <template #left>
              <span class="page-left">
                <span>已选中 {{ checkendSum }}</span>
                <span
                  class="clear"
                  @click.prevent="clearRecords"
                >清空</span>
              </span>
            </template>
          </vxe-pager>
        </div>
      </div>
    </div>
    <InjuryPartEdit
      ref="Editdialog"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-confirm="handleConfirm"
    ></InjuryPartEdit>
    <excel
      controlName="InjuryPart"
      fileName="受伤类型导入模板.xlsx"
      :dialogVisible="UpLoaddialogVisible"
      @close-dialog="closeUpDialog"
      @error="error"
      @success="success"
    ></excel>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { InjuryPart } from "@assets/apiData/InjuryPart";
import {
  GetDatainjuryPartList,
  DeleteinjuryPart,
  SelectinjuryPartById,
  ExportinjuryPart,
} from "@api/ApiInjuryPart";
import InjuryPartEdit from "@comp/Basic/InjuryPartEdit.vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
export default defineComponent({
  name: "InjuryPart",
  components: {
    InjuryPartEdit,
    excel,
  },
  setup() {
    //基础数据
    const data = reactive({
      Query: {
        Name: "",
      },
      show: false,
      selectedRow: null,
      multipleSelection: [],
      UpLoaddialogVisible: false,
    });
    //分页对象
    let pageData = reactive({
      loading: false,
      tabledatas: [],
      currentPage: 1,
      currentSize: 20,
      pagesizes: [20, 50, 100, 500],
      total: 0,
    });
    const multipleTable = ref(null);
    let dialogVisible = ref(false);
    let Editdialog = ref(null);
    let checkendSum = ref(0);
    //查询
    function SearchOpt() {
      pageData.loading = true;
      let PageQuery = {
        pageindex: pageData.currentPage,
        PageSize: pageData.currentSize,
        queryModel: {
          Name: data.Query.Name,
          sortField: {
            CreationTime: "desc",
          },
        },
        orderbyCloums: pageData.orderbyCloums,
      };
      GetDatainjuryPartList(PageQuery)
        .then(({ entities, totalCount }) => {
          pageData.tabledatas = entities;
          pageData.total = totalCount;
          pageData.loading = false;
        })
        .catch(({ mgessage }) => {
          pageData.loading = false;
          ElMessage.error("受伤类型查询失败" + mgessage);
          console.log("受伤类型查询失败", mgessage);
        });
    }
    //跳转页码
    function handlePageChange({ currentPage, pageSize }) {
      if (pageData.currentSize != pageSize) {
        pageData.currentPage = 1; //说明更改了每页展示条数，要从第一页进行展示
        pageData.currentSize = pageSize;
      } else {
        pageData.currentPage = currentPage;
      }
      SearchOpt();
    }
    //当前选中行
    const handleCurrentChange = ({ row }) => {
      data.selectedRow = row;
    };
    //多选
    const handleSelectionChange = ({ records }) => {
      data.multipleSelection = records;
      checkendSum.value = records.length;
    };
    //选中数量
    const selectAllChangeEvent = ({ checked, records }) => {
      data.multipleSelection = records;
      checkendSum.value = records.length;
    };
    //清除选中
    const clearRecords = () => {
      multipleTable.value.clearCheckboxRow();
      checkendSum.value = 0;
    };
    //操作节点
    const Opt = (rowIndex, name) => {
      let { tabledatas } = pageData;
      let id = 0;
      if (name != "New") {
        id = tabledatas[rowIndex].id;
      }
      switch (name) {
        case "New":
          Editdialog.value.initDialog("insert");
          dialogVisible.value = true;
          break;
        case "Edit":
          SelectinjuryPartById(id)
            .then((resultData) => {
              Editdialog.value.initDialog("update", resultData);
              dialogVisible.value = true;
            })
            .catch(({ code, message }) => {
              console.log(message);
              ElMessage.error(message);
            });
          break;
        case "View":
          SelectinjuryPartById(id)
            .then((resultData) => {
              Editdialog.value.initDialog("view", resultData);
              dialogVisible.value = true;
            })
            .catch(({ code, message }) => {
              console.log(message);
              ElMessage.error(message);
            });
          break;
        case "Del":
          DeleteinjuryPart(id)
            .then((res) => SearchOpt())
            .catch((message) => {
              ElMessage.error(message);
            });
          break;
      }
    };
    //弹出框事件
    function closeDialog() {
      dialogVisible.value = false;
      SearchOpt();
    }
    function handleConfirm() {
      SearchOpt();
    }
    function importExcel() {
      data.UpLoaddialogVisible = true;
    }
    function exportExcel() {
      if (data.multipleSelection.length == 0) {
        try {
          let PageQuery = {
            pageindex: pageData.currentPage,
            PageSize: pageData.currentSize,
            queryModel: {
              Name: data.Query.Name,
            },
            orderbyCloums: pageData.orderbyCloums,
          };
          ExportinjuryPart(PageQuery).then((result) => {
            if (result.response.status == 500) {
              ElMessage.warning("查询到的数据为空");
            }
          });
        } catch (e) {
          console.log(e);
        }
      } else {
        export2Excel();
      }
    }
    function export2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(InjuryPart)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(InjuryPart)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名

        const list =
          data.multipleSelection.length == 0
            ? pageData.tabledatas
            : data.multipleSelection;

        const data = formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `工伤认定单`);
      });
    }
    function formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    }
    function error() {}
    function success() {}
    function closeUpDialog() {
      data.UpLoaddialogVisible = false;
      pageData.currentPage = 1;
      data.Query.Name = "";
      SearchOpt();
    }

    //页面初始化
    onMounted(() => {
      SearchOpt();
    });
    return {
      InjuryPart,
      pageData,
      multipleTable,
      checkendSum,
      ...toRefs(data),
      handleCurrentChange,
      handleSelectionChange,
      selectAllChangeEvent,
      clearRecords,
      handlePageChange,
      Opt,
      SearchOpt,
      dialogVisible,
      Editdialog,
      closeDialog,
      handleConfirm,
      importExcel,
      exportExcel,
      error,
      success,
      closeUpDialog,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";

.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}

.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}

.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}

/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #ffffff;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #ffffff;
}

.page-left {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.operation {
  display: flex;
}

.pagination {
  margin: 0;
  width: 100%;
  /* position: absolute;
        bottom: 0; */
  background-color: #fff;
  z-index: 7;
  padding: 5px 0;
}
</style><style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
</style>
<style scoped>
</style>
